import React  from 'react';
import { Button, DialogActions } from '@material-ui/core';
import { useMutation } from 'react-query';
import { updateObjectiveKPIEntry } from '../../../api/objective/objectiveKPIEntry.api';
import { useForm, FormProvider } from 'react-hook-form';
import KPIEntryForm from './KPIEntryForm';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { addAlert } from '../../../actions/alerts.action';

const UpdateKPIEntry = ({
  kpi,
  kpiEntry,
  objective,
  onSubmitSuccess,
  onCancel
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const form = useForm({
    defaultValues: kpiEntry
  });

  const updateMutation = useMutation(
    async values => {
      await updateObjectiveKPIEntry({
        kpiEntry: {
          ...kpiEntry,
          objectiveKPIEntryId: kpiEntry.objective_kpi_entry_id,
          ...values
        },
        kpiId: kpi.objectiveKPIId,
        objectiveId: objective.id,
        ownerId: objective.owner[0].id,
        ownerType: objective.owner[0].type
      });
    },
    {
      onSuccess: () => {
        onSubmitSuccess?.();
      },
      onError: error => {
        dispatch(addAlert({ message: error.message, severity: 'error' }));
      }
    }
  );

  return <FormProvider { ...form }>
    <form onSubmit={ form.handleSubmit(updateMutation.mutate) }>
      <KPIEntryForm kpi={ kpi } />
      <DialogActions style={ { marginTop: 8 } }>
        <Button type='submit' color='primary' variant='contained'>
          { t('objective.dialog.save') }
        </Button>
        <Button onClick={ onCancel } color='primary'>
          { t('objective.dialog.cancel') }
        </Button>
      </DialogActions>
    </form>
  </FormProvider>;
};

export default UpdateKPIEntry;
